import jwtDecode from "jwt-decode";

export class EncodingHelpers {
  /**
   * Generate base64 from file input
   * @param {File} file
   * @returns {Base64}
   */
  static async getBase64FromFile(file = new File()) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      try {
        reader.readAsDataURL(file);
      } catch (error) {
        throw error;
      }

      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => {
        return reject(error);
      };
    });
  }

  /**
   * Some browsers ignore the trailing and white spaces in Base64 inputs, others don't
   * That can create an issue when we try to decode the Base64 on mobile or Safari
   * This function prevents that without loss
   * @param {Base64} Base64 - the Base64 image we want to sanitize
   * @returns {Base64} - sanitized Base64
   */
  static sanitizeBase64(base64Input = "") {
    return base64Input.replace(/\s/g, "");
  }

  /**
   * Simple wrapper for jwtDecode
   * @param token
   * @returns object with data
   */
  static getDecodedJWTToken(token) {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken;
    } catch (error) {
      throw error;
    }
  }
}
